import { useQuery } from "@tanstack/react-query";
import { useToast } from "../../../components/ui/use-toast";
import { useEffect } from "react";
import { getPatientHealthRecords } from "../../../services/doctors";

export function usePatientHealthRecords(
  {
    name,
    mobile,
  }: {
    name: string;
    mobile: string;
  },
  enabled = true,
) {
  const { toast } = useToast();

  const {
    data: healthRecords,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["patient-health-records", enabled, name, mobile],
    queryFn: () => getPatientHealthRecords({ name, mobile }),
    enabled: enabled && !!name && !!mobile,
  });

  useEffect(() => {
    if (isError) {
      // toast({
      //   title: "Failed to fetch health records",
      //   variant: "destructive",
      // });
    }
  }, [isError, toast]);

  return { healthRecords, isLoading };
}
